import React from 'react';
import {
  Button,
  ButtonGroup,
  FormGroup,
  Intent,
} from '@blueprintjs/core';

import {WEEK_DAYS_SHORT} from '../constants';
import {OnChangeCallback} from './types';

interface WeekdaysProps {
  weekdays: string[];
  allSelected?: boolean;
  transformFn?: (value: any) => any;
  onChange: OnChangeCallback;
}

export const Weekdays = ({
  weekdays,
  allSelected = false,
  transformFn = undefined,
  onChange,
}: WeekdaysProps) => {
  const onChangeWeekday = (weekdays: string[], day: string) => {
    let newWeekdays = [...weekdays];
    if (weekdays.indexOf(day) >= 0) {
      // remove
      newWeekdays = newWeekdays.filter(d => d !== day);
    } else {
      // add
      newWeekdays.push(day);
    }
    onChange("weekdays", transformFn)([...newWeekdays]);
  }

  return (
    <FormGroup className="weekdays">
        <ButtonGroup large={false}>
          {
            WEEK_DAYS_SHORT.map((day: string) => {
              const intent = weekdays.indexOf(day) >= 0 || allSelected ? Intent.PRIMARY : Intent.NONE;

              return (
                <Button
                  text={day}
                  key={day}
                  intent={intent}
                  onClick={() => onChangeWeekday(weekdays, day)}/>
              );
            })
          }
        </ButtonGroup>
      </FormGroup>
  )
};

export default Weekdays;
